import { Eye, EyeOff, ShieldCheck } from "lucide-react";
import type { PublicUsage } from "../types";

const labels: Record<PublicUsage, string> = {
  allowed: "Публично разрешено",
  restricted: "После проверки",
  "internal-only": "Только внутри",
};

export function UsageBadge({ usage }: { usage: PublicUsage }) {
  const Icon = usage === "allowed" ? ShieldCheck : usage === "internal-only" ? EyeOff : Eye;
  return (
    <span className={`usage-badge usage-badge--${usage}`}>
      <Icon size={14} aria-hidden="true" />
      {labels[usage]}
    </span>
  );
}
